import React from 'react';
import { Typography } from '@mui/material';
import Tooltip from '@src/components/Tooltip';
import { useTranslation } from 'react-i18next';
import VoucherIcon from '@src/assets/icons/icon-voucher-purple.svg';
import LogoPackVip from '@src/assets/logo/logo-pack-vip.svg';
import GiftGradient from '@src/assets/icons/gift-gradient.svg';
import classNames from 'classnames';
import { PACKAGE_LEVEL, PACKAGE_TYPE } from '@src/constants/package';
import { LANGUAGE } from '@src/constants';
import sanitizeHtml from 'sanitize-html';

const PackageHeader = ({
  pkg,
  bestVoucher,
  isApplyFirstPaidVoucher,
  language,
  isDiscountPackage,
  isDiscountForFirstUser,
  firstPaidVoucher,
}) => {
  const { t } = useTranslation();

  const isPackageVip = pkg?.level === PACKAGE_LEVEL.VIP;
  const isPackageApi = pkg?.type === PACKAGE_TYPE.API;

  const getPackageName = () =>
    pkg?.name?.[language] || pkg?.name?.[LANGUAGE.EN];

  const getPackageDescription = () =>
    language === LANGUAGE.VN
      ? pkg?.description?.[language]
      : pkg?.description?.[LANGUAGE.EN];

  const renderVoucherIcon = () => {
    if (bestVoucher && !isApplyFirstPaidVoucher) {
      return (
        <Tooltip arrow placement="top" title={t('bestVoucherApplied')}>
          {isPackageVip ? (
            <img src={GiftGradient} alt="gift-icon" />
          ) : (
            <div className="voucher-gift-icon">
              <img src={VoucherIcon} alt="voucher-icon" />
            </div>
          )}
        </Tooltip>
      );
    }
    return null;
  };

  const renderDiscountForFirstUser = () => {
    if (!isDiscountForFirstUser) return null;

    const discountForFirstPurchase = t('discountForFirstPurchase', {
      percent: firstPaidVoucher?.value || 0,
    });
    return (
      <Typography
        className="package-limited-deal"
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(discountForFirstPurchase),
        }}
      />
    );
  };

  return (
    <div className="group-package-header">
      <div className="package-header">
        <div className="name-content">
          {isPackageVip && (
            <img src={LogoPackVip} className="crown-icon" alt="crown-icon" />
          )}
          {!isPackageVip && (
            <Typography
              className={classNames('package-name', {
                'package-name-popular': isDiscountPackage || pkg.mostPopular,
                'package-name-vip': isPackageVip,
              })}
            >
              {getPackageName()}
            </Typography>
          )}
        </div>
        {renderDiscountForFirstUser()}
        {renderVoucherIcon()}
      </div>
      {!isPackageApi && (
        <Typography
          className="description-package"
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(getPackageDescription()),
          }}
        />
      )}
    </div>
  );
};

export default PackageHeader;
